import creditCardType from 'credit-card-type';
import { PaymentMethod } from '../../../hooks/usePaymentMethods';

export const createMaskWithLastFour = (method?: PaymentMethod) => {
  if (!method) return '**** **** **** ****';

  const { lastFour, cardType } = method.attributes;
  const type = cardType ? creditCardType.getTypeInfo(cardType) : undefined;

  if (!type) return `**** **** **** ${lastFour}`;

  const { lengths, gaps } = type;

  if (!lengths || !gaps) return `**** **** **** ${lastFour}`;

  const length = lengths[lengths.length - 1];
  const digits = `${Array(length - lastFour.length)
    .fill('*')
    .join('')}${lastFour}`;
  return gaps.reduceRight(
    (mask, gapIndex) => `${mask.slice(0, gapIndex)} ${mask.slice(gapIndex)}`,
    digits
  );
};
